import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AskWrapper } from './components/AskWrapper';

async function loadAskStep(): Promise<typeof AskWrapper> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-ask" */ './components/AskWrapper'))
		.AskWrapper;
}

export const AskLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadAskStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
};

export const preloadAskStep = loadAskStep;
